(function () {
  "use strict";

  /* =====================================================================
     PIRIKS_CONFIG — попълни/провери линковете по-долу
  ===================================================================== */
  var PIRIKS_CONFIG = {
    viber: {
      link: "viber://chat?number=%2B359882104932",
      displayNumber: "+359 88 210 4932"
    },
    voices: [
      { id: "warm-male",       label: "Топъл мъжки",        audioUrl: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/topal-mujki.mp3?v=1790587067" },
      { id: "warm-female",     label: "Топъл женски",       audioUrl: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/topal-jenski.mp3?v=1790587067" },
      { id: "excited-male",    label: "Развълнуван мъжки",  audioUrl: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/razvalnuvan-mujki.mp3?v=1790587067" },
      { id: "excited-female",  label: "Развълнуван женски", audioUrl: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/razvalnuvan-jenski.mp3?v=1790587067" }
    ],
    templates: [
      { id: "komisar-petrov",          label: "Комисар Петров",             audioUrl: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/komisar_petrov.mp3?v=1791366758" },
      { id: "ministerstvo-na-tortite", label: "Министерството на тортите",  audioUrl: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/tortite.mp3?v=1791366759" },
      { id: "portokalov-samurai",      label: "Портокаловия самурай",       audioUrl: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/samurai.mp3?v=1791366758" },
      { id: "sporten-komentator",      label: "Спортен коментатор",         audioUrl: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/komentator.mp3?v=1791366759" },
      { id: "ceremonia-nagrajdavane",  label: "Церемония по награждаване",  audioUrl: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/ceremoniq.mp3?v=1791366759" },
      { id: "vuzrastta-klasificirana", label: "Възрастта е класифицирана",  audioUrl: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/vuzrast.mp3?v=1791366759" }
    ],
    designs: [
      { id: "design1", label: "Дизайн 1", image: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/preview-piriks1.jpg?v=1790508781" },
      { id: "design2", label: "Дизайн 2", image: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/preview-piriks2.jpg?v=1790508781" },
      { id: "design3", label: "Дизайн 3", image: "https://cdn.shopify.com/s/files/1/1050/0102/5878/files/preview-piriks3.jpg?v=1790508782" }
    ],
    // Текст, който се записва в количката/поръчката за добавките със снимка
    photoContactNote: "След поръчката ще се свържем с теб по Viber, за да уточним допълнителните детайли"
  };

  // Ако формата е сложена по погрешка два пъти на страницата, пазим само
  // една (предпочитаме тази с най-новата разметка) и махаме излишните.
  var allForms = Array.prototype.slice.call(document.querySelectorAll("#piriks-personalize"));
  var root = allForms.filter(function (f) { return f.querySelector('[data-upload-details]'); })[0] || allForms[0];
  if (!root) return;
  allForms.forEach(function (f) { if (f !== root && f.parentNode) f.parentNode.removeChild(f); });

  // Защита срещу двойно зареждане на скрипта (напр. два <script> тага в блока):
  // втората инициализация се прескача, за да не се дублират превютата и слушателите.
  if (root.getAttribute("data-piriks-init") === "1") return;
  root.setAttribute("data-piriks-init", "1");

  var state = {
    wishType: null,
    selectedVoice: { write: null, piriks: null },
    selectedTemplate: null,
    selectedDesign: null,
    queue: [] // финализирани картички, чакащи добавяне в количката
  };

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function showField(el, show) { if (el) el.classList.toggle("piriks-hidden", !show); }
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function labelOf(list, id) {
    var found = list.filter(function (x) { return x.id === id; })[0];
    return found ? found.label : "";
  }
  function clearError(selector) {
    var el = root.querySelector(selector);
    if (el) el.textContent = "";
  }

  /* ---------- Viber ---------- */
  var viberLink = root.querySelector('[href^="viber://"]');
  if (viberLink) viberLink.setAttribute("href", PIRIKS_CONFIG.viber.link);
  var viberNumberEl = root.querySelector("[data-viber-number]");
  if (viberNumberEl) viberNumberEl.textContent = PIRIKS_CONFIG.viber.displayNumber;

  /* ---------- audio picker (ползва се за гласове и за готови пожелания) ---------- */
  var activeAudio = null;

  function stopActiveAudio() {
    if (!activeAudio) return;
    activeAudio.pause();
    activeAudio.currentTime = 0;
    var prevItem = activeAudio.closest(".piriks-voice");
    if (prevItem) {
      prevItem.classList.remove("is-playing");
      var prevBtn = prevItem.querySelector(".piriks-voice__play");
      if (prevBtn) prevBtn.textContent = "▶";
    }
    activeAudio = null;
  }

  function renderAudioPicker(container, items, onSelect) {
    if (!container) return;
    container.innerHTML = "";
    items.forEach(function (it) {
      var item = document.createElement("div");
      item.className = "piriks-voice";
      item.setAttribute("data-audio-id", it.id);
      item.innerHTML =
        '<button type="button" class="piriks-voice__play" aria-label="Пусни">▶</button>' +
        '<span class="piriks-voice__label">' + escapeHtml(it.label) + '</span>' +
        '<span class="piriks-voice__bars"><span></span><span></span><span></span></span>' +
        '<span class="piriks-voice__check">✓</span>' +
        '<audio preload="none" src="' + escapeHtml(it.audioUrl) + '"></audio>';
      container.appendChild(item);

      var audioEl = item.querySelector("audio");
      var playBtn = item.querySelector(".piriks-voice__play");

      playBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        if (activeAudio && activeAudio !== audioEl) stopActiveAudio();
        if (audioEl.paused) {
          audioEl.play().catch(function () {});
          playBtn.textContent = "❚❚";
          item.classList.add("is-playing");
          activeAudio = audioEl;
        } else {
          audioEl.pause();
          playBtn.textContent = "▶";
          item.classList.remove("is-playing");
        }
      });

      audioEl.addEventListener("ended", function () {
        playBtn.textContent = "▶";
        item.classList.remove("is-playing");
      });

      item.addEventListener("click", function () {
        $all(".piriks-voice", container).forEach(function (i) { i.classList.remove("is-selected"); });
        item.classList.add("is-selected");
        onSelect(it.id);
      });
    });
  }

  ["write", "piriks"].forEach(function (groupKey) {
    renderAudioPicker(
      root.querySelector('.piriks-voices[data-voice-group="' + groupKey + '"]'),
      PIRIKS_CONFIG.voices,
      function (id) {
        state.selectedVoice[groupKey] = id;
        clearError('[data-error-for="' + groupKey + '-voice"]');
      }
    );
  });

  renderAudioPicker(
    root.querySelector("[data-template-group]"),
    PIRIKS_CONFIG.templates,
    function (id) {
      state.selectedTemplate = id;
      clearError('[data-error-for="template"]');
    }
  );

  /* ---------- design picker ---------- */
  var designContainer = root.querySelector("[data-design-group]");
  designContainer.innerHTML = "";
  PIRIKS_CONFIG.designs.forEach(function (d) {
    var item = document.createElement("div");
    item.className = "piriks-design";
    item.setAttribute("data-design-id", d.id);
    item.innerHTML =
      '<img src="' + escapeHtml(d.image) + '" alt="' + escapeHtml(d.label) + '" loading="lazy">' +
      '<span class="piriks-design__check">✓</span>' +
      '<span class="piriks-design__label">' + escapeHtml(d.label) + '</span>';
    designContainer.appendChild(item);
    item.addEventListener("click", function () {
      $all(".piriks-design", designContainer).forEach(function (i) { i.classList.remove("is-selected"); });
      item.classList.add("is-selected");
      state.selectedDesign = d.id;
      clearError('[data-error-for="design"]');
    });
  });

  /* ---------- occasion "Друг" ---------- */
  var occasionSelect = $("#piriks-occasion");
  var occasionOtherWrap = root.querySelector('[data-field="occasion-other"]');
  occasionSelect.addEventListener("change", function () {
    showField(occasionOtherWrap, occasionSelect.value === "Друг");
  });

  /* ---------- wish type cards ---------- */
  var wishCards = $all(".piriks-card");
  var wishBlocks = $all(".piriks-wish-block");
  wishCards.forEach(function (card) {
    card.addEventListener("click", function () {
      wishCards.forEach(function (c) { c.classList.remove("is-selected"); });
      card.classList.add("is-selected");
      state.wishType = card.getAttribute("data-wish-type");
      wishBlocks.forEach(function (b) {
        showField(b, b.getAttribute("data-wish-block") === state.wishType);
      });
      // Плавно скролваме до разгънатото поле
      var activeBlock = wishBlocks.filter(function (b) { return b.getAttribute("data-wish-block") === state.wishType; })[0];
      if (activeBlock) {
        setTimeout(function () { activeBlock.scrollIntoView({ behavior: "smooth", block: "start" }); }, 60);
      }
    });
  });

  /* ---------- Незадължителна снимка за включената карикатура ---------- */
  var files = { caricature: null };
  var previewUrls = { caricature: null };

  function clearUpload(kind) {
    files[kind] = null;
    $("#piriks-" + kind + "-file").value = "";
    if (previewUrls[kind]) URL.revokeObjectURL(previewUrls[kind]);
    previewUrls[kind] = null;
    var preview = $('[data-preview="' + kind + '"]');
    preview.querySelector("img").removeAttribute("src");
    preview.querySelector("[data-file-name]").textContent = "";
    showField(preview, false);
    clearError('[data-error-for="' + kind + '-file"]');
  }
  ["caricature"].forEach(function (kind) {
    var input = $("#piriks-" + kind + "-file");
    input.addEventListener("change", function () {
      var file = input.files && input.files[0];
      if (!file) return;
      clearUpload(kind);
      var error = $('[data-error-for="' + kind + '-file"]');
      if (["image/jpeg", "image/png", "image/webp"].indexOf(file.type) === -1 || !file.size) {
        error.textContent = "Избери валидна JPG, PNG или WebP снимка.";
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        error.textContent = "Снимката е над 10 MB. Избери по-малка или я изпрати по Viber след поръчката.";
        return;
      }
      files[kind] = file;
      previewUrls[kind] = URL.createObjectURL(file);
      var preview = $('[data-preview="' + kind + '"]');
      preview.querySelector("img").src = previewUrls[kind];
      preview.querySelector("[data-file-name]").textContent = file.name;
      showField(preview, true);
    });
    $('[data-remove-file="' + kind + '"]').addEventListener("click", function () { clearUpload(kind); });
  });
  function currentAddon() {
    return "caricature";
  }

  /* ---------- validation ---------- */
  function fieldError(inputEl, msg) {
    if (!inputEl) return;
    var errSpan = inputEl.nextElementSibling && inputEl.nextElementSibling.classList.contains("piriks-error")
      ? inputEl.nextElementSibling : inputEl.parentElement.querySelector(".piriks-error");
    if (errSpan) errSpan.textContent = msg || "";
    inputEl.classList.toggle("is-invalid", !!msg);
  }

  function validateStep1() {
    var valid = true;
    var firstInvalid = null;
    function mark(el, msg) {
      fieldError(el, msg);
      if (msg) { valid = false; if (!firstInvalid) firstInvalid = el; }
    }
    function markBox(errSelector, msg) {
      var errEl = root.querySelector(errSelector);
      if (!errEl) return;
      errEl.textContent = msg || "";
      if (msg) { valid = false; if (!firstInvalid) firstInvalid = errEl; }
    }

    mark(occasionSelect, occasionSelect.value ? "" : "Моля, изберете повод.");
    if (occasionSelect.value === "Друг") {
      var otherInput = $("#piriks-occasion-other");
      mark(otherInput, otherInput.value.trim() ? "" : "Моля, опишете повода.");
    }

    var wishTypeWrap = root.querySelector('[data-field="wish-type"]');
    if (!state.wishType) {
      markBox('[data-error-for="wish-type"]', "Моля, изберете вид пожелание.");
      if (!firstInvalid) firstInvalid = wishTypeWrap;
    } else {
      markBox('[data-error-for="wish-type"]', "");

      if (state.wishType === "write") {
        var wText = $("#piriks-write-text");
        mark(wText, wText.value.trim() ? "" : "Моля, напишете пожелание.");
        markBox('[data-error-for="write-voice"]', state.selectedVoice.write ? "" : "Моля, изберете глас.");
      }

      if (state.wishType === "record") {
        markBox('[data-error-for="record-confirm"]', $("#piriks-record-confirm").checked ? "" : "Моля, потвърди.");
      }

      if (state.wishType === "template") {
        [["#piriks-tpl-from", "Моля, попълни от кого е."], ["#piriks-tpl-to", "Моля, попълни за кого е."]].forEach(function (p) {
          var el = $(p[0]); mark(el, el.value.trim() ? "" : p[1]);
        });
        markBox('[data-error-for="template"]', state.selectedTemplate ? "" : "Моля, избери готово пожелание.");
      }

      if (state.wishType === "piriks") {
        [["#piriks-p-from", "Моля, попълни от кого е."], ["#piriks-p-to", "Моля, попълни за кого е."]].forEach(function (p) {
          var el = $(p[0]); mark(el, el.value.trim() ? "" : p[1]);
        });
        var styleSel = $("#piriks-p-style");
        mark(styleSel, styleSel.value ? "" : "Моля, избери стил.");
        markBox('[data-error-for="piriks-voice"]', state.selectedVoice.piriks ? "" : "Моля, изберете глас.");
      }
    }

    markBox('[data-error-for="design"]', state.selectedDesign ? "" : "Моля, избери дизайн.");

    if (firstInvalid) firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
    return valid;
  }

  /* ---------- properties на текущата картичка ---------- */
  function buildCurrentCardProperties() {
    var props = {};
    props["Повод"] = occasionSelect.value === "Друг" ? $("#piriks-occasion-other").value.trim() : occasionSelect.value;

    var wishLabels = { write: "Написано от клиента", record: "Собствен запис (Viber)", template: "Готов темплейт", piriks: "PIRIKS ще създаде" };
    props["Вид пожелание"] = wishLabels[state.wishType] || "";

    if (state.wishType === "write") {
      props["Текст на пожеланието"] = $("#piriks-write-text").value.trim();
      if ($("#piriks-write-from").value.trim()) props["От"] = $("#piriks-write-from").value.trim();
      if ($("#piriks-write-to").value.trim()) props["За"] = $("#piriks-write-to").value.trim();
      props["Избран глас"] = labelOf(PIRIKS_CONFIG.voices, state.selectedVoice.write);
    }
    if (state.wishType === "record") {
      props["Метод"] = "Гласово съобщение по Viber (изпратено отделно)";
    }
    if (state.wishType === "template") {
      props["От"] = $("#piriks-tpl-from").value.trim();
      props["За"] = $("#piriks-tpl-to").value.trim();
      props["Готово пожелание"] = labelOf(PIRIKS_CONFIG.templates, state.selectedTemplate);
      if ($("#piriks-tpl-extra").value.trim()) props["Допълнителна информация"] = $("#piriks-tpl-extra").value.trim();
    }
    if (state.wishType === "piriks") {
      props["От"] = $("#piriks-p-from").value.trim();
      props["За"] = $("#piriks-p-to").value.trim();
      props["Стил"] = $("#piriks-p-style").value;
      if ($("#piriks-p-extra").value.trim()) props["Допълнителна информация"] = $("#piriks-p-extra").value.trim();
      props["Избран глас"] = labelOf(PIRIKS_CONFIG.voices, state.selectedVoice.piriks);
    }

    props["Дизайн на картичката"] = labelOf(PIRIKS_CONFIG.designs, state.selectedDesign);

    props["Карикатура"] = "Включена — безплатно (0 €)";
    props["Уточняване"] = PIRIKS_CONFIG.photoContactNote;
    props["Снимка за карикатурата"] = files.caricature ? "Прикачена: " + files.caricature.name : "Ще бъде изпратена по Viber след поръчката";
    var caricatureExtra = $("#piriks-caricature-extra").value.trim();
    if (caricatureExtra) props["Уточнение за карикатурата"] = caricatureExtra;
    return props;
  }

  function buildCurrentCard() {
    return { properties: buildCurrentCardProperties(), addon: currentAddon(), file: files[currentAddon()] || null };
  }

  /* ---------- reset на стъпка 1 (за "Добави още 1 картичка") ---------- */
  function resetStep1Form() {
    stopActiveAudio();

    occasionSelect.value = "";
    showField(occasionOtherWrap, false);
    $("#piriks-occasion-other").value = "";

    wishCards.forEach(function (c) { c.classList.remove("is-selected"); });
    wishBlocks.forEach(function (b) { showField(b, false); });
    state.wishType = null;

    ["#piriks-write-text", "#piriks-write-from", "#piriks-write-to",
     "#piriks-tpl-from", "#piriks-tpl-to", "#piriks-tpl-extra",
     "#piriks-p-from", "#piriks-p-to", "#piriks-p-style", "#piriks-p-extra", "#piriks-caricature-extra"].forEach(function (sel) { $(sel).value = ""; });
    $("#piriks-record-confirm").checked = false;

    $all(".piriks-voice").forEach(function (v) { v.classList.remove("is-selected", "is-playing"); });
    $all(".piriks-voice__play").forEach(function (b) { b.textContent = "▶"; });
    state.selectedVoice = { write: null, piriks: null };
    state.selectedTemplate = null;

    clearUpload("caricature");
    $("[data-upload-details]").open = false;

    $all(".piriks-design", designContainer).forEach(function (d) { d.classList.remove("is-selected"); });
    state.selectedDesign = null;

    root.querySelectorAll(".piriks-error").forEach(function (e) { e.textContent = ""; });
    root.querySelectorAll(".is-invalid").forEach(function (e) { e.classList.remove("is-invalid"); });
  }

  /* ---------- стъпка 2: преглед ---------- */
  function summaryHtml(card) {
    var html = "";
    Object.keys(card.properties).forEach(function (k) {
      var v = card.properties[k];
      // скрити служебни полета и дублиращите се "добавка" редове (показваме ги отдолу)
      if (!v || k.charAt(0) === "_" || k === "Карикатура") return;
      html += "<dt>" + escapeHtml(k) + "</dt><dd>" + escapeHtml(v) + "</dd>";
    });
    if (card.addon === "caricature") {
      html += "<dt>Добавка</dt><dd>Карикатура — безплатно (0 €).</dd>";
    }
    return html;
  }

  function renderStep2() {
    var queueBox = root.querySelector("[data-queue-box]");
    queueBox.innerHTML = "";
    state.queue.forEach(function (card, idx) {
      var el = document.createElement("div");
      el.className = "piriks-queue-item";
      el.innerHTML =
        '<div class="piriks-queue-item__head"><strong>Картичка ' + (idx + 1) + '</strong>' +
        '<button type="button" class="piriks-queue-item__remove" data-remove-idx="' + idx + '">премахни</button></div>' +
        "<dl>" + summaryHtml(card) + "</dl>";
      queueBox.appendChild(el);
    });
    queueBox.querySelectorAll("[data-remove-idx]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.queue.splice(parseInt(btn.getAttribute("data-remove-idx"), 10), 1);
        renderStep2();
      });
    });

    root.querySelector("[data-summary-box]").innerHTML =
      '<div class="piriks-queue-item__head"><strong>Нова картичка (' + (state.queue.length + 1) + ')</strong></div>' +
      "<dl>" + summaryHtml(buildCurrentCard()) + "</dl>";

    root.querySelector("[data-cart-count]").textContent = state.queue.length + 1;
  }

  /* ---------- навигация ---------- */
  function goToStep(n) {
    $all(".piriks-step").forEach(function (s) { showField(s, s.getAttribute("data-step") == n); });
    $all(".piriks-progress__step").forEach(function (s) {
      var i = parseInt(s.getAttribute("data-step-indicator"), 10);
      s.classList.toggle("is-active", i === n);
      s.classList.toggle("is-done", i < n);
    });
  }

  root.querySelector('[data-action="go-to-summary"]').addEventListener("click", function () {
    if (!validateStep1()) return;
    stopActiveAudio();
    renderStep2();
    goToStep(2);
    root.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  root.querySelector('[data-action="back-to-edit"]').addEventListener("click", function () { goToStep(1); });

  root.querySelector('[data-action="add-another"]').addEventListener("click", function () {
    state.queue.push(buildCurrentCard());
    resetStep1Form();
    goToStep(1);
    root.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  /* ---------- финално добавяне в количката ---------- */
  function findProductForm() {
    var scope = root.closest("[data-section-id], section, .shopify-section") || document;
    return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }

  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
    setTimeout(function () {
      var drawerVisible = document.querySelector("cart-drawer.active, .cart-drawer.is-open, #CartDrawer.is-open");
      if (!drawerVisible) {
        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart";
      }
    }, 600);
  }

  root.querySelector('[data-action="add-to-cart"]').addEventListener("click", function () {
    var btn = this;
    var statusEl = root.querySelector("[data-submit-status]");
    var form = findProductForm();
    if (!form) { statusEl.textContent = "Грешка: не е намерена продуктовата форма."; statusEl.className = "piriks-submit-status is-error"; return; }

    var variantId = new FormData(form).get("id");
    if (!variantId) { statusEl.textContent = "Грешка: липсва избран вариант."; statusEl.className = "piriks-submit-status is-error"; return; }

    var allCards = state.queue.concat([buildCurrentCard()]);

    // FormData запазва двоичните файлове; JSON би загубил съдържанието им.
    var payload = new FormData();
    allCards.forEach(function (card, idx) {
      var prefix = "items[" + idx + "]";
      var groupId = "piriks-" + Date.now() + "-" + idx;
      var props = Object.assign({}, card.properties, { "_piriks_group": groupId });
      payload.append(prefix + "[id]", variantId);
      payload.append(prefix + "[quantity]", "1");
      Object.keys(props).forEach(function (key) {
        payload.append(prefix + "[properties][" + key + "]", props[key]);
      });
      if (card.file) {
        payload.append(prefix + "[properties][Прикачена снимка]", card.file, card.file.name);
      }
    });

    var actionButtons = $all(".piriks-actions button, [data-remove-idx]");
    actionButtons.forEach(function (button) { button.disabled = true; });
    statusEl.textContent = "Добавяне в количката...";
    statusEl.className = "piriks-submit-status";

    var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart/add.js";

    fetch(cartAddUrl, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: payload
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || "Грешка при добавяне в количката."); });
        return res.json();
      })
      .then(function () {
        statusEl.textContent = "Добавено успешно в количката!";
        statusEl.className = "piriks-submit-status is-success";
        state.queue = [];
        goToStep(3);
        refreshCartDrawer();
      })
      .catch(function (err) {
        console.error("[PIRIKS] Add to cart error", err);
        statusEl.textContent = err.message || "Възникна грешка. Опитайте отново.";
        statusEl.className = "piriks-submit-status is-error";
      })
      .finally(function () { actionButtons.forEach(function (button) { button.disabled = false; }); });
  });

})();